import React from 'react';
import SingleBanners from "./SingleBanners";
import BannerImage from "./BannerImage";

const Banners = () => {
    return (
        <div className="middle-banners-wrapper xmt-16 xmt-lg-20">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6">
                        <SingleBanners text="پیشنهاد طلایی" color="gold"/>
                    </div>
                    <div className="col-lg-6 xmt-4 xmt-lg-0">
                        {/*<SingleBanners text="میان رده های باکیفیت" color="purple"/>*/}
                        <BannerImage/>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Banners;
